export default function getUrlParam(param) {
  return new URLSearchParams(window.location.search).get(param);
}



// WEBPACK FOOTER //
// ./src/helpers/getUrlParam.js